module.exports = __webpack_public_path__ + "img/smiling_face_with_halo.3e79ae2f.gif";